@if (maintenanceService.isInMaintenance()) {
  <lib-maintenance-page />
} @else {
  <lib-loading />

  <ng-template modal>
    <lib-modal-component />
  </ng-template>

  <lib-toast aria-live="polite"
    aria-atomic="true"
   />

  <header>
    <app-header />
  </header>

  <main>
    <router-outlet />
  </main>

  <lib-footer class="footer"
    [showDisclaimer]="false"
   />
}
